import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
// Order is load-bearing: globals.css aliases its palette onto these tokens, and
// legenda.css consumes them for the domain primitives.
import './styles/legenda.tokens.css';
import './styles/legenda.css';
import './styles/globals.css';

const ONE_MINUTE_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Archive manifests, source groups and borehole registries change on
      // import, not on navigation — refetching them per focus is pure noise.
      staleTime: 5 * ONE_MINUTE_MS,
      gcTime: 30 * ONE_MINUTE_MS,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден корневой элемент #root — проверьте index.html.');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
